<div class="row my-1 justify-content-between">
    <div class="col-12 col-lg-4 d-flex flex-column justify-content-around">
        <div class="row">
            <div class="col-auto pe-0">
                <strong class="user-select-auto">{{ strings.weekDay }} {{ strings.startDateTime }}</strong>
                <span *ngIf="isMultiDayNotification"> -<br /></span>
                <strong class="user-select-auto">{{ strings.endDateTime }}</strong>
                <a class="cursor-pointer" *ngIf="displayDurationChange" (click)="openDurationModal()">
                    <fa-icon [icon]="faPencil" class="ms-1"></fa-icon>
                </a>
            </div>
            <div class="col d-lg-none d-block ps-0">
                <pace-notification-status-badge
                    [notification]="notification"
                    [notificationStatus]="notification.updatedStatus"
                    [showUnreadIcon]="false"
                ></pace-notification-status-badge>
            </div>
        </div>
        <div class="row">
            <div class="col mt-1 mt-lg-0">
                <span
                    ><a
                        class="cursor-pointer user-select-auto"
                        (click)="openCustomerModal()"
                        role="button"
                        [attr.aria-label]="'NOTIFICATION_DETAILS_ADDRESS_INFO_TITLE' | translate"
                        >{{ notification.address.completeName }}</a
                    ></span
                >
            </div>
        </div>
        <div class="row">
            <div class="col mt-1 mt-lg-0">
                <span class="user-select-auto">{{ notificationTypeString }}</span>
                <fa-icon *ngIf="notification.isRemoteSupport" [icon]="faPhone" size="lg" class="ps-2"></fa-icon>
            </div>
        </div>
        <div *ngIf="displayClarifyText" class="row">
            <div class="col mt-1 mt-lg-0">
                <span class="user-select-auto" [innerHTML]="notification.clarifyText | paceUrl"></span>
            </div>
        </div>
        <div *ngIf="displayANALink" class="row">
            <div class="col mt-1 mt-lg-0">
                <span
                    ><a
                        class="cursor-pointer user-select-auto"
                        (click)="openANALink()"
                        role="button"
                        [attr.aria-label]="'NOTIFICATION_DETAILS_MARKET_MAP_LABEL' | translate"
                        >MarketMap</a
                    ></span
                >
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-4 mt-3 mt-lg-0 ms-auto">
        <div class="row mb-1 mb-lg-0" *ngIf="descText">
            <strong class="col-3" translate="NOTIFICATION_DETAILS_HEADER_SYSTEM_LABEL"></strong>
            <div class="col-9">
                <span class="notification-detail-text user-select-auto">{{ descText }}</span>
                <span *ngIf="displayInternalInfo" class="internal-info ms-1" (click)="openInternalInfoModal()">
                    <fa-icon [icon]="faNewspaper"></fa-icon>&nbsp;
                    <span class="badge rounded-pill bg-primary d-inline">{{ availableInternalInfoCounts }}</span>
                </span>
            </div>
        </div>
        <div class="row mb-1 mb-lg-0" *ngIf="tidorFLNumber">
            <strong
                class="col-3"
                *ngIf="displayTechnicalIdNumber"
                translate="NOTIFICATION_DETAILS_HEADER_TID_LABEL"
            ></strong>
            <strong
                class="col-3"
                *ngIf="displayFunctionLocation"
                translate="NOTIFICATION_DETAILS_HEADER_FUNCTIONAL_LOCATION_LABEL"
            ></strong>
            <div class="col-9">
                <span class="notification-detail-text user-select-auto">{{ tidorFLNumber }}</span>
                <a
                    class="cursor-pointer"
                    *ngIf="notification.objectInformationLongText.length > 0"
                    (click)="openObjectInfoModal()"
                >
                    <fa-icon [icon]="faInfoCircle" class="ms-1"></fa-icon>
                </a>
            </div>
        </div>
        <div class="row mb-1 mb-lg-0" *ngIf="displayContract">
            <strong class="col-3" translate="NOTIFICATION_DETAILS_HEADER_CONTRACT_LABEL"></strong>
            <div class="col-9">
                <span class="notification-detail-text user-select-auto">{{ contractType }}</span>
                <fa-icon [icon]="faBan" *ngIf="!contractType" class="ms-1"></fa-icon>
                <a
                    class="cursor-pointer"
                    *ngIf="notification.contract.sections.length > 0"
                    (click)="openContractModal()"
                >
                    <fa-icon [icon]="faInfoCircle" class="ms-1"></fa-icon>
                </a>
            </div>
        </div>
        <div class="row mb-1 mb-lg-0" *ngIf="displayCustomerPONumber()">
            <strong class="col-3" translate="NOTIFICATION_DETAILS_HEADER_AKZ_LABEL"></strong>
            <span class="col-9 notification-detail-text user-select-auto">{{ customerPurchOrder }}</span>
        </div>
        <div class="row mb-1 mb-lg-0" *ngIf="displayEquipment">
            <strong class="col-3" translate="NOTIFICATION_DETAILS_HEADER_EQUIPMENT"></strong>
            <span class="col-9 notification-detail-text user-select-auto">{{ equipmentNumber }}</span>
        </div>
        <div class="row mb-1 mb-lg-0" *ngIf="displayModality">
            <strong class="col-3" translate="NOTIFICATION_DETAILS_HEADER_MODALITY"></strong>
            <span class="col-9 notification-detail-text user-select-auto">{{ modality }}</span>
        </div>
        <div class="row mb-1 mb-lg-0" *ngIf="displayCriticality">
            <strong class="col-3" translate="NOTIFICATION_DETAILS_HEADER_CRITICALITY"></strong>
            <div class="col-9">
                <span class="notification-detail-text user-select-auto">{{ criticality }}</span>
                <a
                    class="cursor-pointer"
                    (click)="openCriticalityModal()"
                    *ngIf="notification.updatedStatus.canChangeCriticality()"
                >
                    <fa-icon [icon]="faPencil" class="ms-1"></fa-icon>
                </a>
            </div>
        </div>
        <div class="row mb-1 mb-lg-0" *ngIf="displayApprovedPCH">
            <strong class="col-3 pe-0" translate="NOTIFICATION_DETAILS_HEADER_APPROVED_PCH"></strong>
            <div class="col-9">
                <ng-container *ngIf="!approvedPCHDurationModel.noPCHAvailable; else noPCH">
                    <span class="notification-detail-text user-select-auto mb-0">{{
                        approvedPCHDurationModel.approvedPCHDuration.start
                    }}</span>
                    <span> &nbsp;- <br /></span>
                    <span class="notification-detail-text user-select-auto mb-0">{{
                        approvedPCHDurationModel.approvedPCHDuration.end
                    }}</span>
                </ng-container>
                <ng-template #noPCH>
                    <span class="notification-detail-text user-select-auto mb-0 text-warning">{{
                        'NOTIFICATION_DETAILS_HEADER_NO_APPROVED_PCH' | translate
                    }}</span>
                </ng-template>

                <a class="cursor-pointer" (click)="openPCHDurationModal()">
                    <fa-icon [icon]="faPencil" class="ms-1"></fa-icon>
                </a>
            </div>
        </div>
    </div>
    <div class="col-5 col-lg-4 d-lg-flex flex-column justify-content-around">
        <ng-content></ng-content>
    </div>

    <div class="row my-1">
        <div class="col d-flex justify-content-end d-lg-none">
            <fa-icon *ngIf="notification.userStatus" class="me-1" [icon]="faFlag"></fa-icon>
            <span>{{ notification.userStatus }}</span>
        </div>
    </div>
</div>
